import cookies from 'js-cookie'
import { ga } from '../application'
import { default as settings, load as loadSettings } from './settings'
import { commonStrings, loadCommon as loadCommonStrings } from './strings'
import { textBuilder } from './textBuilder'
import TextHandler from './textHandler'
import { default as urls, load as loadUrls } from './urls'

const tests = {}

const hostname = window.location.hostname
const match = /\.(se|dk|fi|no)/.exec(hostname)
const language = match && match.length > 0 ? match[1] : 'se'

const environment = () => {
  if (/localhost/i.test(hostname)) return 'local'
  if (/st3.tuiprjuat[.|-]/i.test(hostname)) return 'uat'
  if (/st5.tuiprjuat[.|-]/i.test(hostname)) return 'uat2'
  if (/[.|-]uat[.|-]/i.test(hostname)) return 'uat'
  if (/[.|-]uat2[.|-]/i.test(hostname)) return 'uat2'
  return 'prod'
}

const getApiKey = (environment, language) => {
  switch (language) {
    case 'no':
      return environment === 'prod' ? '4_e1-Pm5LtmAcMQJa88aiC1g' : '4_9oM3gA6l0ymGyg0MKnqaOw'
    case 'dk':
      return environment === 'prod' ? '4_m8JrxiPbcgmKbE4q_34S6g' : '4_Go2AbgSI0CpFd287J4mccw'
    case 'fi':
      return environment === 'prod' ? '4_Y80AQl6x_yzGcmQaIZfnmQ' : '4_MqLPDG97Rzwqx4naJPms-Q'
    case 'se':
    default:
      return environment === 'prod' ? '4_rCrnl3452eBx6CXDj4Q-Fw' : '4_FgV6_7c0L_ujbUog6mUHVg'
  }
}

const setupTests = (environment) => {
  const segmentValue = cookies.get('tui_segment')
  tests.switcher_repeater = false
  tests.tuiblue = true
  tests.selfService = true
  tests.GDN = true
  tests.ATI = true
  tests.disturbance = false

  if (!segmentValue) return

  if (segmentValue >= 1 && segmentValue <= 50) {
    ga.experiment('MyTui Original')
  }
  if (segmentValue > 51 && segmentValue <= 100) {
    // Variation should be named with suffix Variation 1, 2 etc. (e.g MyTui Recent User Login Variation 1)
  }
}

const loadResources = async (modal) => {
  await loadSettings(environment(), language, modal)
  await loadCommonStrings(language)
  await loadUrls(language, settings.hostName)
  setupTests(environment())
}

const textHandler = new TextHandler()
const apiKey = getApiKey(environment(), language)

export { commonStrings, tests, settings, urls, apiKey, loadResources, textBuilder, language, textHandler }
